(function () {
  "use strict";

  const CATEGORIES = [
    ["inUse", "已選珠子", "◎"], ["rock", "石頭種類", "◇"], ["element", "五行", "五"],
    ["zodiac", "星座", "✦"], ["animal", "生肖", "卯"], ["emotion", "情緒", "♡"],
    ["month", "月份／誕生石", "12"], ["chakra", "脈輪", "◉"], ["color", "顏色", "●"], ["gift", "送禮推薦", "禮"]
  ];
  const OPTIONS = {
    element:["金","木","水","火","土"], zodiac:["牡羊座","金牛座","雙子座","巨蟹座","獅子座","處女座","天秤座","天蠍座","射手座","摩羯座","水瓶座","雙魚座"],
    animal:["鼠","牛","虎","兔","龍","蛇","馬","羊","猴","雞","狗","豬"], emotion:["平靜","放鬆","專注","自信","勇氣","希望","幸福","成長","祝福","感恩","鼓勵"],
    month:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"], chakra:["海底輪","臍輪","太陽神經叢輪","心輪","喉輪","眉心輪","頂輪"],
    color:["白色","粉色","紅色","紫色","藍色","綠色","黃色","橙色","棕色","灰色","黑色"], gift:["自己","媽媽","爸爸","老婆","老公","女朋友","男朋友","朋友","閨蜜","同事","老師","客戶","長輩"]
  };
  const WEIGHT = {rock:50,color:35,element:25,zodiac:20,animal:15,chakra:15,month:20,emotion:10,gift:10};
  const MIN_SLOT_COUNT = 10;
  const MAX_SLOT_COUNT = 34;
  const DEFAULT_WRIST_CM = 16;
  const ENGRAVING_PRICE = 100;
  const CULTURE_FALLBACK = {
    "粉水晶":{elements:["火","土"],zodiacs:["金牛座","巨蟹座","天秤座"],animals:["兔","羊","豬"],emotions:["幸福","祝福","感恩","鼓勵"],months:[],chakras:["心輪","臍輪"],gift:["自己","媽媽","老婆","女朋友","閨蜜"]},
    "紫水晶":{elements:["火"],zodiacs:["雙魚座","處女座","水瓶座"],animals:["兔","蛇","豬"],emotions:["平靜","放鬆","專注","成長","祝福"],months:["二月"],chakras:["眉心輪","頂輪"],gift:["自己","朋友","老師"]},
    "白水晶":{elements:["金","水"],zodiacs:["雙子座","處女座","水瓶座"],animals:["鼠","龍","猴"],emotions:["平靜","專注","成長","祝福"],months:[],chakras:["頂輪"],gift:["自己","朋友"]},
    "黃水晶":{elements:["土"],zodiacs:["牡羊座","獅子座","射手座"],animals:["虎","龍","馬"],emotions:["自信","希望","幸福","成長","祝福"],months:["十一月"],chakras:["太陽神經叢輪"],gift:["自己","朋友","同事","客戶"]},
    "月光石":{elements:["水"],zodiacs:["巨蟹座","天秤座","雙魚座"],animals:["兔","羊","豬"],emotions:["平靜","希望","成長","祝福"],months:["六月"],chakras:["眉心輪","頂輪"],gift:["自己","朋友","媽媽"]},
    "幽靈水晶":{elements:["木","土"],zodiacs:["金牛座","處女座","摩羯座"],animals:["牛","龍","狗"],emotions:[],months:[],chakras:["心輪"],gift:["朋友","長輩"]},
    "白瑪瑙":{elements:["金","水"],zodiacs:["雙子座","處女座","水瓶座"],animals:["鼠","龍","猴"],emotions:[],months:[],chakras:["頂輪"],gift:["朋友","長輩","女朋友"]},
    "紅膠花水晶":{elements:["火","土"],zodiacs:["牡羊座","獅子座","天蠍座"],animals:["虎","龍","馬"],emotions:[],months:[],chakras:["海底輪","臍輪"],gift:["朋友","長輩"]},
    "黑瑪瑙":{elements:["水","土"],zodiacs:["天蠍座","摩羯座","水瓶座"],animals:["牛","狗","豬"],emotions:[],months:[],chakras:["海底輪"],gift:["朋友","長輩","女朋友"]},
    "茶水晶":{elements:["土","水"],zodiacs:["金牛座","天蠍座","摩羯座"],animals:["牛","蛇","狗"],emotions:["平靜","專注","勇氣","成長"],months:[],chakras:["海底輪"],gift:["自己","朋友","同事"]},
    "青金石":{elements:["水","金"],zodiacs:["射手座","摩羯座","水瓶座"],animals:["龍","蛇","狗"],emotions:["平靜","專注","成長"],months:[],chakras:["喉輪","眉心輪"],gift:["自己","朋友","爸爸"]},
    "黑曜石":{elements:["水"],zodiacs:["天蠍座","摩羯座","水瓶座"],animals:["牛","蛇","狗"],emotions:["勇氣","自信","專注"],months:[],chakras:["海底輪"],gift:["自己","朋友","同事"]},
    "金曜石":{elements:["水","金"],zodiacs:["獅子座","天蠍座","摩羯座"],animals:["虎","龍","雞"],emotions:["自信","勇氣","希望","成長"],months:[],chakras:["海底輪","太陽神經叢輪"],gift:["自己","朋友","同事","客戶"]},
    "草莓晶":{elements:["火","土"],zodiacs:["牡羊座","巨蟹座","天秤座"],animals:["兔","羊","豬"],emotions:["幸福","祝福","鼓勵"],months:[],chakras:["心輪","臍輪"],gift:["自己","女朋友","閨蜜","朋友"]},
    "海藍寶":{elements:["水"],zodiacs:["雙子座","天秤座","雙魚座"],animals:["鼠","龍","豬"],emotions:["平靜","勇氣","自信","希望"],months:["三月"],chakras:["喉輪"],gift:["自己","朋友","媽媽"]},
    "銀曜石":{elements:["水","金"],zodiacs:["處女座","天蠍座","水瓶座"],animals:["鼠","蛇","狗"],emotions:["平靜","專注","自信","成長"],months:[],chakras:["海底輪","頂輪"],gift:["自己","朋友","同事","老師"]}
  };

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"}[c]));
  }
  function stoneGroup(name) {
  const value = String(name || "").replace(/\s+/g, "").replace(/宝/g,"寶").replace(/胶/g,"膠").replace(/红/g,"紅");

  if (value.includes("草莓晶")) return "草莓晶";
  if (value.includes("粉水晶") || value.includes("粉晶")) return "粉水晶";
  if (value.includes("紫水晶")) return "紫水晶";
  if (value.includes("白水晶")) return "白水晶";
  if (value.includes("黃水晶")) return "黃水晶";
  if (value.includes("月光")) return "月光石";
  if (value.includes("紅膠花")) return "紅膠花水晶";
  if (value.includes("幽靈")) return "幽靈水晶";
  if (value.includes("白瑪瑙")) return "白瑪瑙";
  if (value.includes("黑瑪瑙")) return "黑瑪瑙";
  if (value.includes("金曜石")) return "金曜石";
  if (value.includes("銀曜石")) return "銀曜石";
  if (value.includes("黑曜石")) return "黑曜石";
  if (value.includes("海藍寶")) return "海藍寶";
  if (value.includes("青金石")) return "青金石";
  if (value.includes("茶水晶")) return "茶水晶";
  if (value.includes("黃塔晶")) return "黃塔晶";
  if (value.includes("紫玉")) return "紫玉";

  return value
    .replace(/^[578]A/, "")
    .replace(/^天然/, "")
    .replace(/^巴西/, "")
    .replace(/^冰種/, "")
    .replace(/^冰透/, "");
}
  function colorForName(name) {
    const value = String(name || "").replace(/宝/g,"寶").replace(/胶/g,"膠").replace(/红/g,"紅");
    if (/綠草莓/.test(value)) return "綠色";
    if (/粉|芙蓉|草莓/.test(value)) return "粉色";
    if (/紅膠花|牛血紅/.test(value)) return "紅色";
    if (/紫/.test(value)) return "紫色";
    if (/海藍|藍月|青金/.test(value)) return "藍色";
    if (/橙月/.test(value)) return "橙色";
    if (/灰月/.test(value)) return "灰色";
    if (/黃/.test(value)) return "黃色";
    if (/茶|千層幽靈/.test(value)) return "棕色";
    if (/黑曜|金曜|銀曜|黑瑪瑙/.test(value)) return "黑色";
    return "白色";
  }
  function traditionalText(value) {
    return String(value || "")
      .replace(/马/g, "馬")
      .replace(/胶/g, "膠")
      .replace(/宝/g, "寶")
      .replace(/红/g, "紅");
  }
  function enrichCulture(bead) {
    const fallback = CULTURE_FALLBACK[stoneGroup(bead.name)] || {};
    const arrayValue = key => Array.isArray(bead[key]) && bead[key].length ? bead[key] : (fallback[key] || []);
    return {...bead, name:traditionalText(bead.name),
      elements:arrayValue("elements"), zodiacs:arrayValue("zodiacs"), animals:arrayValue("animals"),
      emotions:arrayValue("emotions"), months:arrayValue("months"), chakras:arrayValue("chakras"),
      gift:arrayValue("gift"), color:bead.color || fallback.color || colorForName(bead.name)
    };
  }
  function valuesFor(bead, key) {
    if (key === "rock") return [stoneGroup(bead.name)];
    if (key === "element") return bead.elements;
    if (key === "zodiac") return bead.zodiacs;
    if (key === "animal") return bead.animals;
    if (key === "emotion") return bead.emotions;
    if (key === "month") return bead.months;
    if (key === "chakra") return bead.chakras;
    if (key === "color") return [bead.color];
    if (key === "gift") return bead.gift;
    return [];
  }
  function recommendation(bead, filters) {
    const entries = Object.entries(filters).filter(([, value]) => value);
    const matches = entries.filter(([key, value]) => valuesFor(bead, key).includes(value));
    const score = matches.reduce((sum, [key]) => sum + (WEIGHT[key] || 0), 0);
    const max = entries.reduce((sum, [key]) => sum + (WEIGHT[key] || 0), 0);
    return {matches, score, percent:max ? Math.round(score / max * 100) : 0};
  }
  function imageFor(bead, size) { return bead.images[size + "mm"] || bead.images.master; }
  function money(value) { return "NT$" + Number(value).toLocaleString("zh-TW"); }
  function braceletBeadPx(size) { return ({6:22,8:30,10:34,12:38,14:42}[Number(size)] || 30); }
  function productBeadPx(size) { return ({6:56,8:64,10:70,12:76,14:82}[Number(size)] || 64); }
  function xmlEscape(value) {
    return String(value || "").replace(/[&<>"']/g, character => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&apos;"}[character]));
  }

  function init(root) {
    if (!root || root.dataset.initialized === "true") return;
    const source = root.querySelector("[data-may-diy-beads]");
    const app = root.querySelector("[data-may-diy-app]");
    if (!source || !app) return;
    const isEnglish = String(root.dataset.language || document.documentElement.lang || "")
      .toLowerCase()
      .startsWith("en");
    const tr = (zh, en) => isEnglish ? en : zh;
    const ENGLISH_UI = {
      "已選珠子":"Selected Beads", "石頭種類":"Crystal Types", "五行":"Five Elements",
      "星座":"Zodiac", "生肖":"Chinese Zodiac", "情緒":"Emotional Needs",
      "月份／誕生石":"Month / Birthstone", "脈輪":"Chakras", "顏色":"Color",
      "送禮推薦":"Gift Guide", "選珠方式":"How to Choose", "從妳在意的條件開始":"Start with what matters to you",
      "篩選珠子":"Choose Beads", "排列手串":"Arrange Bracelet", "完成設計":"Complete Design",
      "目前條件":"Current Filters", "尚未選擇，顯示全部珠子":"No filters selected — showing all beads",
      "全部清除":"Clear All", "已加入手串的珠子":"Beads in Your Bracelet", "我的手串":"My Bracelet",
      "清空":"Clear", "目標手圍":"Wrist Size", "已選":"Selected", "預估":"Estimated",
      "左移":"Move Left", "刪除":"Remove", "右移":"Move Right", "重複":"Repeat", "復原":"Undo",
      "智慧推薦":"Smart Suggestions", "預估總額":"Estimated Total", "前往結算":"Proceed to Checkout",
      "選擇五行、星座或情緒後，只顯示完全符合條件的珠子。":"Choose Five Elements, Zodiac, or Emotional Needs to show only matching beads.",
      "五行、星座、生肖、脈輪與誕生石月份來自已核准的文化 Relation；情緒與送禮關聯目前僅供測試。文化內容為生活選擇參考，不屬礦物科學或療效說明。":"Five Elements, Zodiac, Chinese Zodiac, Chakras, and birthstone months use approved cultural references. Emotional and gift links are for selection guidance only. Cultural content is not mineral science or a medical claim.",
      "繼續調整":"Continue Editing", "客製刻字":"Custom Engraving", "需要客製刻字":"Add custom engraving",
      "刻字內容":"Engraving Text", "確認刻字":"Confirm Engraving", "已設定：":"Saved:", "移除":"Remove",
      "金":"Metal", "木":"Wood", "水":"Water", "火":"Fire", "土":"Earth",
      "牡羊座":"Aries", "金牛座":"Taurus", "雙子座":"Gemini", "巨蟹座":"Cancer",
      "獅子座":"Leo", "處女座":"Virgo", "天秤座":"Libra", "天蠍座":"Scorpio",
      "射手座":"Sagittarius", "摩羯座":"Capricorn", "水瓶座":"Aquarius", "雙魚座":"Pisces",
      "鼠":"Rat", "牛":"Ox", "虎":"Tiger", "兔":"Rabbit", "龍":"Dragon", "蛇":"Snake",
      "馬":"Horse", "羊":"Goat", "猴":"Monkey", "雞":"Rooster", "狗":"Dog", "豬":"Pig",
      "平靜":"Calm", "放鬆":"Relaxation", "專注":"Focus", "自信":"Confidence", "勇氣":"Courage",
      "希望":"Hope", "幸福":"Happiness", "成長":"Growth", "祝福":"Blessings", "感恩":"Gratitude", "鼓勵":"Encouragement",
      "一月":"January", "二月":"February", "三月":"March", "四月":"April", "五月":"May", "六月":"June",
      "七月":"July", "八月":"August", "九月":"September", "十月":"October", "十一月":"November", "十二月":"December",
      "海底輪":"Root Chakra", "臍輪":"Sacral Chakra", "太陽神經叢輪":"Solar Plexus Chakra",
      "心輪":"Heart Chakra", "喉輪":"Throat Chakra", "眉心輪":"Third Eye Chakra", "頂輪":"Crown Chakra",
      "白色":"White", "粉色":"Pink", "紅色":"Red", "紫色":"Purple", "藍色":"Blue", "綠色":"Green",
      "黃色":"Yellow", "橙色":"Orange", "棕色":"Brown", "灰色":"Gray", "黑色":"Black",
      "自己":"Myself", "媽媽":"Mother", "爸爸":"Father", "老婆":"Wife", "老公":"Husband",
      "女朋友":"Girlfriend", "男朋友":"Boyfriend", "朋友":"Friend", "閨蜜":"Best Friend",
      "同事":"Colleague", "老師":"Teacher", "客戶":"Client", "長輩":"Elder"
    };
    function englishUiText(value) {
      if (!isEnglish) return value;
      const original = String(value || "");
      const trimmed = original.trim();
      if (!trimmed) return original;
      let text = original;
      text = text
        .replace(/(\d+)\s*顆\s*·\s*預估手圍\s*([0-9.]+)\s*cm/g, "$1 beads · Estimated size $2 cm")
        .replace(/手圍接近\s*([0-9.]+)\s*cm\s*後即可完成設計/g, "Complete the design when the bracelet is close to $1 cm")
        .replace(/距離\s*([0-9.]+)\s*cm\s*還差約\s*([0-9.]+)\s*cm/g, "$2 cm remaining to reach $1 cm")
        .replace(/還差約\s*([0-9.]+)\s*cm/g, "$1 cm remaining")
        .replace(/已達目標手圍\s*([0-9.]+)\s*cm/g, "Target wrist size reached: $1 cm")
        .replace(/Selected\s+(\d+)\s+個條件/g, "$1 filters selected")
        .replace(/(\d+)\s+種珠材/g, "$1 bead materials")
        .replace(/(\d+)\s+顆/g, "$1 beads")
        .replace(/每顆/g, "per bead")
        .replace(/目前選擇/g, "Selected size")
        .replace(/符合：/g, "Matches: ")
        .replace(/選珠/g, " Selection")
        .replace(/完成這條手串\s*→/g, "Complete This Bracelet →")
        .replace(/妳的專屬手串設計已完成。/g, "Your custom bracelet design is complete.")
        .replace(/目前手串已排滿；繼續點選左側珠子即可加入第\s*(\d+)\s*顆。/g, "The bracelet is full. Select another bead to add position $1.")
        .replace(/目前選取第\s*(\d+)\s*個位置，點左邊珠子即可加入。/g, "Position $1 is selected. Choose a bead on the left to add it.")
        .replace(/選擇五行、星座或情緒後，只顯示完全符合條件的珠子。/g, "Choose Five Elements, Zodiac, or Emotional Needs to show only matching beads.")
        .replace(/已依照「([^」]+)」精準篩選；不符合的珠子已隱藏。/g, "Filtered by “$1”; non-matching beads are hidden.")
        .replace(/五行、星座、生肖、脈輪與誕生石月份來自已核准的文化 Relation；情緒與送禮關聯目前僅供測試。文化內容為生活選擇參考，不屬礦物科學或療效說明。/g, "Five Elements, Zodiac, Chinese Zodiac, Chakras, and birthstone months use approved cultural references. Emotional and gift links are for selection guidance only. Cultural content is not mineral science or a medical claim.")
        .replace(/搜尋珠子名稱⋯/g, "Search bead names...")
        .replace(/搜尋珠子/g, "Search beads")
        .replace(/互動示意版/g, "Start your custom design");
      if (ENGLISH_UI[text.trim()]) return text.replace(text.trim(), ENGLISH_UI[text.trim()]);
      Object.entries(ENGLISH_UI).forEach(([zh, en]) => { text = text.split(zh).join(en); });
      text = text.replace(/手圍/g, "wrist size");
      return text;
    }
    function humanizeEnglishStoneName(value) {
      if (!isEnglish) return value;
      const compact = String(value || "").replace(/\s+/g, "");
      const aliases = {
        NaturalYellowTowerQuartz: "Yellow Tower Quartz",
        NaturalDreamAmethyst: "Dream Amethyst",
        NaturalMadagascarRoseQuartz: "Madagascar Rose Quartz",
        ClearQuartz: "Clear Quartz",
        NaturalRoseQuartz: "Rose Quartz",
        NaturalPhantomQuartz: "Phantom Quartz",
        naturalwhiteagate: "White Agate"
      };
      if (aliases[compact]) return aliases[compact];
      return String(value || "")
        .replace(/^Natural/i, "")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim();
    }
    function translateEnglishUi() {
      if (!isEnglish) return;
      const walker = document.createTreeWalker(app, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => { node.nodeValue = englishUiText(node.nodeValue); });
      app.querySelectorAll("[placeholder],[aria-label],[title]").forEach(element => {
        ["placeholder", "aria-label", "title"].forEach(attribute => {
          if (element.hasAttribute(attribute)) element.setAttribute(attribute, englishUiText(element.getAttribute(attribute)));
        });
      });
    }
    let beads;
    try { beads = JSON.parse(source.textContent).map(enrichCulture); } catch (error) { console.error("May DIY bead data error", error); return; }
    root.dataset.initialized = "true";
    const engravingPrice = Number(root.dataset.engravingPrice) || ENGRAVING_PRICE;
    const designUploadUrl = String(root.dataset.designUploadUrl || "").trim();
    const initialSizes = Object.fromEntries(beads.map(bead => {
      const sizes = Object.keys(bead.prices || {}).map(Number).filter(Number.isFinite).sort((a,b) => a-b);
      return [bead.id, sizes.includes(8) ? 8 : sizes[0]];
    }));
    const state = {
      active:"rock", filters:{}, query:"", sizes:initialSizes, selectedSlot:0,
      targetWrist:DEFAULT_WRIST_CM,
      history:[], finished:false,
      engraving:{enabled:false, selectedSlot:null, items:[], draftText:"", error:""},
      slots:Array(MAX_SLOT_COUNT).fill(null)
    };

    function designId() {
      return `MAY-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2,7).toUpperCase()}`;
    }
    function designItems() {
      return state.slots.slice(0, visibleSlotCount()).map((item, index) => item ? {
        slot:index + 1,
        diyId:item.bead.diyId,
        beadId:item.bead.id,
        name:item.bead.name,
        size:item.size,
        image:imageFor(item.bead, item.size)
      } : null).filter(Boolean);
    }
    function designSequence(items) {
      return items.map(item => `${item.slot}.${item.name}${item.size}mm`).join(" → ").slice(0, 240);
    }
        function designPreviewSvg(id, items) {
      const width = 900;
      const center = 450;
      const radius = Math.max(210, Math.min(310, 175 + items.length * 5));

      const images = items.map((item, index) => {
        const angle = (index / items.length) * Math.PI * 2 - Math.PI / 2;
        const beadSize = Math.max(52, Math.min(92, Number(item.size) * 7));
        const x = center + Math.cos(angle) * radius - beadSize / 2;
        const y = center + Math.sin(angle) * radius - beadSize / 2;

        return `<image href="${xmlEscape(item.image)}" x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${beadSize}" height="${beadSize}" preserveAspectRatio="xMidYMid meet"/>`;
      }).join("");

      return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${width}" viewBox="0 0 ${width} ${width}"><rect width="100%" height="100%" rx="36" fill="#f8f4ee"/><circle cx="${center}" cy="${center}" r="${radius}" fill="none" stroke="#d9cfc4" stroke-width="3" stroke-dasharray="8 10"/>${images}<text x="${center}" y="420" text-anchor="middle" font-family="Arial,sans-serif" font-size="30" fill="#263746">梅May飾界</text><text x="${center}" y="463" text-anchor="middle" font-family="Arial,sans-serif" font-size="21" fill="#6c7780">DIY 專屬客製手串</text><text x="${center}" y="500" text-anchor="middle" font-family="Arial,sans-serif" font-size="16" fill="#8b949b">${xmlEscape(id)}</text></svg>`;
    }
    function designSvg(id, items) {
  const width = 1100;
  const centerX = 550;
  const centerY = 430;
  const radius = 300;
  const legendRows = Math.ceil(items.length / 2);
  const height = 900 + legendRows * 46 + 90;

  const images = items.map((item, index) => {
    const angle = (index / items.length) * Math.PI * 2 - Math.PI / 2;
    const beadSize = Math.max(54, Math.min(96, Number(item.size) * 7.2));
    const x = centerX + Math.cos(angle) * radius - beadSize / 2;
    const y = centerY + Math.sin(angle) * radius - beadSize / 2;
    const labelX = centerX + Math.cos(angle) * (radius + 62);
    const labelY = centerY + Math.sin(angle) * (radius + 62) + 5;
    const label = `${String(item.slot).padStart(2, "0")}・${item.size}mm`;

    return `<image href="${xmlEscape(item.image)}" x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${beadSize}" height="${beadSize}" preserveAspectRatio="xMidYMid meet"/><text x="${labelX.toFixed(1)}" y="${labelY.toFixed(1)}" text-anchor="middle" font-family="Arial,sans-serif" font-size="15" fill="#42515d" stroke="#f8f4ee" stroke-width="7" paint-order="stroke">${label}</text>`;
  }).join("");

  const legend = items.map((item, index) => {
    const column = index % 2;
    const row = Math.floor(index / 2);
    const x = 90 + column * 510;
    const y = 900 + row * 46;
    const number = String(item.slot).padStart(2, "0");

    return `<text x="${x}" y="${y}" font-family="Arial,sans-serif" font-size="20" fill="#33434f"><tspan font-weight="700">${number}</tspan><tspan dx="14">${xmlEscape(item.name)}</tspan><tspan dx="10" fill="#8b6f57">・${item.size}mm</tspan></text>`;
  }).join("");

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="100%" height="100%" rx="36" fill="#f8f4ee"/><circle cx="${centerX}" cy="${centerY}" r="${radius}" fill="none" stroke="#d9cfc4" stroke-width="3" stroke-dasharray="8 10"/>${images}<text x="${centerX}" y="390" text-anchor="middle" font-family="Arial,sans-serif" font-size="30" fill="#263746">梅May飾界</text><text x="${centerX}" y="435" text-anchor="middle" font-family="Arial,sans-serif" font-size="22" fill="#6c7780">DIY 智慧選珠設計圖</text><text x="${centerX}" y="475" text-anchor="middle" font-family="Arial,sans-serif" font-size="18" fill="#8b949b">${xmlEscape(id)}</text><line x1="70" y1="840" x2="1030" y2="840" stroke="#d9cfc4"/><text x="70" y="875" font-family="Arial,sans-serif" font-size="18" letter-spacing="3" fill="#9a8167">BEAD ORDER・珠子順序與規格</text>${legend}</svg>`;
}
    async function uploadDesign(id, items) {
      if (!designUploadUrl) return "";
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(designUploadUrl, {
          method:"POST",
          headers:{"Content-Type":"application/json"},
          body:JSON.stringify({designId:id,previewSvg:designPreviewSvg(id, items),svg:designSvg(id, items),items,targetWrist:state.targetWrist,estimatedWrist:Number(estimatedWrist().toFixed(1)),engravingItems:state.engraving.items}),
          signal:controller.signal
        });
        if (!response.ok) throw new Error(await response.text());
        const result = await response.json();
        return {
  url:String(result.url || result.designUrl || ""),
  previewUrl:String(result.previewUrl || "")
};
      } finally {
        clearTimeout(timeout);
      }
    }

    let dragData = null;
let suppressNextClick = false;
    const normalizedImageCache = new Map();

    function normalizePreviewImages() {
      app.querySelectorAll('img[data-normalize-image="true"]').forEach(img => {
        const sourceUrl = img.getAttribute("src");
        const cacheKey = sourceUrl;
        if (!sourceUrl || img.dataset.cleaning === "true") return;
        if (normalizedImageCache.has(cacheKey)) {
          img.src = normalizedImageCache.get(cacheKey);
          return;
        }
        img.dataset.cleaning = "true";
        const clean = () => {
          try {
            const canvas = document.createElement("canvas");
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            if (!width || !height) return;
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext("2d", {willReadFrequently:true});
            context.drawImage(img, 0, 0);
            const imageData = context.getImageData(0, 0, width, height);
            const pixels = imageData.data;
            const visited = new Uint8Array(width * height);
            const queue = new Int32Array(width * height);
            let head = 0;
            let tail = 0;
            const isEdgeBackground = pixelIndex => {
              const offset = pixelIndex * 4;
              if (pixels[offset + 3] < 20) return true;
              const high = Math.max(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
              const low = Math.min(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
              return low > 208 && high - low < 38;
            };
            const enqueue = pixelIndex => {
              if (pixelIndex < 0 || pixelIndex >= width * height || visited[pixelIndex] || !isEdgeBackground(pixelIndex)) return;
              visited[pixelIndex] = 1;
              queue[tail++] = pixelIndex;
            };
            for (let x = 0; x < width; x += 1) { enqueue(x); enqueue((height - 1) * width + x); }
            for (let y = 0; y < height; y += 1) { enqueue(y * width); enqueue(y * width + width - 1); }
            while (head < tail) {
              const pixelIndex = queue[head++];
              const x = pixelIndex % width;
              const y = Math.floor(pixelIndex / width);
              pixels[pixelIndex * 4 + 3] = 0;
              if (x > 0) enqueue(pixelIndex - 1);
              if (x < width - 1) enqueue(pixelIndex + 1);
              if (y > 0) enqueue(pixelIndex - width);
              if (y < height - 1) enqueue(pixelIndex + width);
            }
            context.putImageData(imageData, 0, 0);
            let left = width;
            let top = height;
            let right = -1;
            let bottom = -1;
            for (let y = 0; y < height; y += 1) {
              for (let x = 0; x < width; x += 1) {
                if (pixels[(y * width + x) * 4 + 3] > 18) {
                  left = Math.min(left, x);
                  top = Math.min(top, y);
                  right = Math.max(right, x);
                  bottom = Math.max(bottom, y);
                }
              }
            }
            if (right < left || bottom < top) return;
            const padding = Math.max(2, Math.round(Math.max(right - left, bottom - top) * 0.035));
            left = Math.max(0, left - padding);
            top = Math.max(0, top - padding);
            right = Math.min(width - 1, right + padding);
            bottom = Math.min(height - 1, bottom + padding);
            const cropped = document.createElement("canvas");
            cropped.width = right - left + 1;
            cropped.height = bottom - top + 1;
            cropped.getContext("2d").drawImage(canvas, left, top, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
            const normalized = cropped.toDataURL("image/png");
            normalizedImageCache.set(cacheKey, normalized);
            img.src = normalized;
          } catch (error) {
            console.warn("May DIY image normalization skipped", error);
          }
        };
        if (img.complete) clean();
        else img.addEventListener("load", clean, {once:true});
      });
    }

    function pick(bead, size) { const chosenSize = size || 8; return {bead, size:chosenSize, price:bead.prices[chosenSize], variantId:bead.variantIds?.[chosenSize]}; }
    function engravingSlot(index) { const item = state.slots[index]; return item ? {index, beadId:item.bead.id, beadName:item.bead.name, size:item.size} : null; }
    function commit(next) { state.history.push(state.slots.map(item => item ? {...item} : null)); state.history = state.history.slice(-20); state.slots = next; }
    function filledItems() { return state.slots.filter(Boolean); }
    function estimatedWrist() { return filledItems().reduce((sum, item) => sum + Number(item.size || 0), 0) / 10; }
    function wristReady() { return estimatedWrist() >= state.targetWrist - 0.5; }
    function visibleSlotCount() {
      const items = filledItems();
      const averageSize = items.length ? items.reduce((sum, item) => sum + Number(item.size || 8), 0) / items.length : 8;
      const required = Math.ceil(state.targetWrist * 10 / Math.max(6, averageSize));
      const lastUsed = state.slots.reduce((last, item, index) => item ? index + 1 : last, 0);
      return Math.min(MAX_SLOT_COUNT, Math.max(MIN_SLOT_COUNT, required, lastUsed));
    }
    function nextEmptySlot(afterIndex) {
      const count = visibleSlotCount();
      for (let offset = 1; offset <= count; offset += 1) {
        const index = (afterIndex + offset) % count;
        if (!state.slots[index]) return index;
      }
      return count < MAX_SLOT_COUNT ? count : -1;
    }
    function chosenFilters() { return Object.entries(state.filters).filter(([,value]) => value); }
    function displayed() {
      const used = new Set(state.slots.filter(Boolean).map(item => item.bead.id));
      let list = state.active === "inUse" ? beads.filter(bead => used.has(bead.id)) : beads.slice();
      const query = state.query.trim().toLowerCase();
      if (query) list = list.filter(bead => (bead.name + " " + bead.english).toLowerCase().includes(query));
      const entries = chosenFilters();
      if (entries.length) list = list.filter(bead => entries.every(([key,value]) => valuesFor(bead,key).includes(value)));
      return list.sort((a,b) => recommendation(b,state.filters).score - recommendation(a,state.filters).score);
    }
    function renderCategories() {
      return CATEGORIES.map(([key,label,icon]) => {
        const options = key === "rock"
  ? [...new Set(beads.map(bead => stoneGroup(bead.name)))]
  : (OPTIONS[key] || []);
        const sub = state.active === key && key !== "inUse" ? `<div class="sub-options">${options.map(option => `<button type="button" data-action="filter" data-key="${key}" data-value="${escapeHtml(option)}" class="${state.filters[key] === option ? "is-selected" : ""}"><span>${escapeHtml(key === "rock" ? humanizeEnglishStoneName(option) : option)}</span>${state.filters[key] === option ? "<b>✓</b>" : ""}</button>`).join("")}</div>` : "";
        return `<div class="category-group"><button type="button" data-action="category" data-key="${key}" class="category-button ${state.active === key ? "is-active" : ""}"><i>${icon}</i><span>${label}</span><b>›</b></button>${sub}</div>`;
      }).join("");
    }
    function renderProducts(list) {
      if (!list.length) return `<div class="empty-result"><span>◇</span><h2>這組條件暫時沒有完全符合的珠子</h2><p>移除一個條件，查看其他符合的選擇。</p><button type="button" data-action="clear-filters">查看全部珠子</button></div>`;
      return `<div class="product-grid">${list.map(bead => {
        const size = state.sizes[bead.id] || 8;
        const rec = recommendation(bead,state.filters);
        const sizes = Object.keys(bead.prices)
  .map(Number)
  .filter(number =>
    Number.isFinite(number) &&
    bead.prices[number] !== undefined &&
    bead.prices[number] !== null
  )
  .sort((a, b) => a - b)
  .map(number =>
    `<button
      type="button"
      data-action="size"
      data-id="${bead.id}"
      data-size="${number}"
      class="${size === number ? "is-active" : ""}">
      <span>${number} mm</span>
      <strong>${money(bead.prices[number])}</strong>
    </button>`
  )
  .join("");
        return `<article class="product-card">${chosenFilters().length && rec.score ? `<b class="recommended">推薦 ${rec.percent}%</b>` : ""}<div class="product-orb"><button type="button" class="bead-image-button" data-action="add" data-id="${bead.id}" aria-label="選擇${bead.name} ${size}mm"><img data-normalize-image="true" crossorigin="anonymous" ${stoneGroup(bead.name) === "金曜石" ? 'data-remove-white="true"' : ""} src="${imageFor(bead,size)}" alt="${bead.name} ${size}mm" style="width:${productBeadPx(size)}px;height:${productBeadPx(size)}px"></button></div><h2>${bead.name}</h2><div class="size-prices">${sizes}</div><p class="current-variant">目前選擇 <strong>${size} mm・每顆 ${money(bead.prices[size])}</strong></p>${rec.matches.length ? `<p class="match-reason">符合：${rec.matches.map(([,value]) => value).join("・")}</p>` : ""}<button type="button" data-action="add" data-id="${bead.id}" aria-label="加入${bead.name}">＋</button></article>`;
      }).join("")}</div>`;
    }
    function renderBracelet() {
  const count = visibleSlotCount();
  const items = state.slots.slice(0, count).filter(Boolean);
  const averagePx = items.length
    ? items.reduce((sum, item) => sum + braceletBeadPx(item.size), 0) / items.length
    : braceletBeadPx(8);
  const radius = Math.max(78, Math.min(108, averagePx * 1.06 * count / (2 * Math.PI)));
  return state.slots.slice(0, count).map((item, index) => {
    const angle = (360 / count) * index - 90;
    const x = Math.cos(angle * Math.PI / 180) * radius;
    const y = Math.sin(angle * Math.PI / 180) * radius;
    const engravingItem = state.engraving.items.find(
      engraving => engraving.slot === index
    );

    const beadPx = item ? braceletBeadPx(item.size) : 20;

    const content = item
      ? `<img data-normalize-image="true" crossorigin="anonymous" src="${imageFor(item.bead, item.size)}" alt="" style="width:${beadPx}px;height:${beadPx}px;--bead-angle:${angle}deg">
         ${engravingItem ? '<span class="engraving-badge" aria-hidden="true">✦</span>' : ""}`
      : "<span>＋</span>";

    return `<button
      type="button"
      data-action="slot"
      data-index="${index}"
      class="mini-slot ${item ? "has-bead" : "is-empty"} ${state.selectedSlot === index ? "is-selected" : ""} ${engravingItem ? "engraving-selected" : ""}"
      style="width:${beadPx}px;height:${beadPx}px;transform:translate(calc(-50% + ${x}px),calc(-50% + ${y}px));"
      aria-label="第${index + 1}個位置${engravingItem ? `，已刻字：${escapeHtml(engravingItem.text)}` : ""}"
      ${engravingItem ? `data-engraving-text="${escapeHtml(engravingItem.text)}"` : ""}
    >${content}</button>`;
  }).join("");
}
    function engravingError(value) {
      const text = String(value || "").trim();
      if (!text) return "請輸入刻字內容";
      if (/^[A-Za-z0-9]+$/.test(text)) return text.length <= 10 ? "" : "英文與數字最多 10 個字符";
      if (/^[\u3400-\u9fff]+$/.test(text)) return Array.from(text).length <= 4 ? "" : "中文最多 4 字";
      return "請輸入最多 4 個中文字，或最多 10 個英文字母／數字";
    }
    function engravingProperties() {
      if (!state.engraving.enabled) return {"客製刻字":"不需要"};
      const lines = state.engraving.items.map(item => `第${item.slot + 1}顆 ${item.beadName}${item.size} ${item.text}`);
      const fee = state.engraving.items.length * engravingPrice;
      return {"客製刻字":"需要","刻字內容":lines.join("\n"),"刻字數量":String(state.engraving.items.length),"刻字費":String(fee)};
    }
    function renderEngraving() {
      const engraving = state.engraving;
      const selected = engraving.selectedSlot;
      const selectedEngraving = selected ? engraving.items.find(item => item.slot === selected.index) : null;
      const fee = engraving.items.length * engravingPrice;
      const items = engraving.items.map(item => `<div class="engraving-item"><span><b>第${item.slot + 1}顆・${escapeHtml(item.beadName)} ${escapeHtml(item.size)}</b><small>${escapeHtml(item.text)}</small></span><button type="button" data-action="engraving-remove" data-index="${item.slot}" aria-label="移除第${item.slot + 1}顆刻字">移除</button></div>`).join("");
      return `<section class="engraving-module" aria-labelledby="engraving-title"><div class="engraving-heading"><div><span>✨ CUSTOM ENGRAVING</span><h3 id="engraving-title">客製刻字</h3></div><strong>每顆 ${money(engravingPrice)}</strong></div><label class="engraving-toggle"><input type="checkbox" data-action="engraving-toggle" ${engraving.enabled ? "checked" : ""}> <span>需要客製刻字</span></label>${engraving.enabled ? `<div class="engraving-selected-slot">${selected ? `<small>目前選擇：</small><strong>第 ${selected.index + 1} 顆</strong><span>${escapeHtml(selected.beadName)} ${selected.size}mm</span>${selectedEngraving ? `<em>已刻字：${escapeHtml(selectedEngraving.text)}</em>` : ""}` : `<strong>請先選擇要刻字的珠子</strong>`}</div>${selected ? `<label class="engraving-text"><span>刻字內容</span><input type="text" data-action="engraving-text" value="${escapeHtml(engraving.draftText)}" maxlength="10" autocomplete="off" aria-describedby="engraving-help engraving-error" aria-invalid="${engraving.error ? "true" : "false"}" placeholder="平安喜樂／LOVE2026"><small id="engraving-help">中文最多 4 字；英文與數字最多 10 個字符</small><em id="engraving-error" aria-live="polite">${escapeHtml(engraving.error)}</em></label><button type="button" class="engraving-confirm" data-action="engraving-confirm">確認刻字</button>` : ""}${items ? `<div class="engraving-list"><span>已設定：</span>${items}</div>` : ""}<div class="engraving-fee"><span>${engraving.items.length} 顆刻字</span><strong>+${money(fee)}</strong></div>` : ""}</section>`;
    }
    function render() {
      const entries = chosenFilters();
      const list = displayed();
      const filled = state.slots.filter(Boolean).length;
      const slotCount = visibleSlotCount();
      const wristCm = estimatedWrist();
      const remainingCm = Math.max(0, state.targetWrist - wristCm);
      const ready = wristReady();
      const currentStep = ready ? 3 : (filled ? 2 : 1);
      const beadTotal = state.slots.reduce((sum,item) => sum + (item ? Number(item.price || 0) : 0), 0);
      const engravingFee = state.engraving.enabled ? state.engraving.items.length * engravingPrice : 0;
      const total = beadTotal + engravingFee;
      const heading = escapeHtml(root.dataset.heading || "智慧 DIY 選珠");
      app.innerHTML = `<main class="picker-shell"><header class="picker-header"><div class="picker-brand"><strong>梅May飾界</strong><span>${heading}</span></div><div class="header-steps step-${currentStep}"><b>1</b><span>篩選珠子</span><i></i><b>2</b><span>排列手串</span><i></i><b>3</b><span>完成設計</span></div><span class="demo-label">${escapeHtml(root.dataset.demoLabel || "互動示意版")}</span></header>
      <section class="picker-layout"><aside class="filter-rail"><div class="rail-title"><span>選珠方式</span><strong>從妳在意的條件開始</strong></div><nav aria-label="珠子篩選方式">${renderCategories()}</nav><p>可跨分類組合篩選，例如「五行・水＋雙魚座＋平靜陪伴」。</p></aside>
      <section class="bead-browser"><div class="browser-top"><label class="search-box"><span>⌕</span><input data-action="search" aria-label="搜尋珠子" placeholder="搜尋珠子名稱⋯" value="${escapeHtml(state.query)}"></label><button type="button" class="filter-count">已選 ${entries.length} 個條件</button></div><div class="active-filter-bar"><div><span>目前條件</span>${entries.length ? entries.map(([key,value]) => `<button type="button" data-action="remove-filter" data-key="${key}">${CATEGORIES.find(item => item[0] === key)[1]}・${escapeHtml(value)} ×</button>`).join("") : "<em>尚未選擇，顯示全部珠子</em>"}</div>${entries.length ? '<button type="button" data-action="clear-filters">全部清除</button>' : ""}</div><div class="result-title"><div><p>${state.active === "inUse" ? "IN USE" : "CRYSTAL LIBRARY"}</p><h1>${state.active === "inUse" ? "已加入手串的珠子" : CATEGORIES.find(item => item[0] === state.active)[1] + "選珠"}</h1></div><span>${list.length} 種珠材</span></div>${renderProducts(list)}<p class="data-note">五行、星座、生肖、脈輪與誕生石月份來自已核准的文化 Relation；情緒與送禮關聯目前僅供測試。文化內容為生活選擇參考，不屬礦物科學或療效說明。</p></section>
      <aside class="bracelet-panel"><div class="panel-heading"><div><p>YOUR BRACELET</p><h2>我的手串</h2></div><button type="button" data-action="clear-bracelet">清空</button></div><label class="wrist-selector"><span>目標手圍</span><select data-action="wrist" aria-label="目標手圍">${[14,15,16,17,18,19,20].map(cm => `<option value="${cm}" ${state.targetWrist === cm ? "selected" : ""}>${cm} cm</option>`).join("")}</select></label><div class="mini-bracelet" aria-label="手串排列預覽"><div class="mini-string"></div>${renderBracelet()}<div class="mini-center"><small>已選</small><strong>${filled} 顆</strong><em>預估 ${wristCm.toFixed(1)} cm</em></div></div><p class="wrist-status ${ready ? "is-ready" : ""}">${ready ? `已達目標手圍 ${state.targetWrist} cm` : `距離 ${state.targetWrist} cm 還差約 ${remainingCm.toFixed(1)} cm`}</p><p class="slot-hint">${state.selectedSlot >= slotCount ? `目前手串已排滿；繼續點選左側珠子即可加入第 ${state.selectedSlot + 1} 顆。` : `目前選取第 ${state.selectedSlot+1} 個位置，點左邊珠子即可加入。`}</p><div class="slot-actions"><button type="button" data-action="move" data-direction="-1" ${state.slots[state.selectedSlot] ? "" : "disabled"}>← 左移</button><button type="button" data-action="remove" ${state.slots[state.selectedSlot] ? "" : "disabled"}>刪除</button><button type="button" data-action="move" data-direction="1" ${state.slots[state.selectedSlot] ? "" : "disabled"}>右移 →</button><button type="button" data-action="repeat" ${state.slots[state.selectedSlot] ? "" : "disabled"}>重複</button><button type="button" data-action="undo" ${state.history.length ? "" : "disabled"}>復原</button></div><div class="ai-mini"><span>✦ 智慧推薦</span><p>${entries.length ? `已依照「${entries.map(([,value]) => value).join("＋")}」精準篩選；不符合的珠子已隱藏。` : "選擇五行、星座或情緒後，只顯示完全符合條件的珠子。"}</p></div>${renderEngraving()}<div class="panel-total"><span><small>${filled} 顆 · 預估手圍 ${wristCm.toFixed(1)} cm</small><strong>預估總額</strong></span><em>${money(total)}</em></div>${!ready ? `<p class="finish-hint">手圍接近 ${state.targetWrist} cm 後即可完成設計</p>` : ""}<button type="button" class="finish-button" data-action="finish" ${ready ? "" : "disabled"}>${ready ? "完成這條手串 →" : `還差約 ${remainingCm.toFixed(1)} cm`}</button></aside></section>
      ${state.finished ? `<div class="finish-layer"><div class="finish-card" role="dialog" aria-modal="true"><span>✓</span><p>SMART DIY COMPLETE</p><h2>妳的專屬手串設計已完成。</h2><div><small>${filled} 顆 · 預估手圍 ${wristCm.toFixed(1)} cm</small><strong>${money(total)}</strong></div><button type="button" class="finish-checkout" data-action="checkout">前往結算</button><button type="button" data-action="close">繼續調整</button></div></div>` : ""}</main>`;
      translateEnglishUi();
      normalizePreviewImages();
    }
    app.addEventListener("input", event => {
      if (event.target.matches('[data-action="search"]')) { state.query = event.target.value; render(); const input=app.querySelector('[data-action="search"]'); input.focus(); input.setSelectionRange(state.query.length,state.query.length); }
      if (event.target.matches('[data-action="engraving-text"]')) {
        state.engraving.draftText = event.target.value;
        state.engraving.error = engravingError(state.engraving.draftText);
        event.target.setAttribute("aria-invalid", String(Boolean(state.engraving.error)));
        const error = app.querySelector("#engraving-error");
        if (error) error.textContent = state.engraving.error;
      }
      if (event.target.matches('[data-action="wrist"]')) { state.targetWrist = Number(event.target.value) || DEFAULT_WRIST_CM; state.selectedSlot = Math.min(state.selectedSlot, visibleSlotCount() - 1); render(); }
    });
    app.addEventListener("click", async event => {
  if (suppressNextClick) {
    suppressNextClick = false;
    return;
  }
      const button = event.target.closest("[data-action]"); if (!button) return;
      const action = button.dataset.action;
      const returnToResults = ["category","filter","remove-filter","clear-filters"].includes(action);
      if (action === "category") state.active = button.dataset.key;
      if (action === "filter") state.filters[button.dataset.key] = state.filters[button.dataset.key] === button.dataset.value ? undefined : button.dataset.value;
      if (action === "remove-filter") state.filters[button.dataset.key] = undefined;
      if (action === "clear-filters") state.filters = {};
      if (action === "size") state.sizes[button.dataset.id] = Number(button.dataset.size);
      if (action === "engraving-toggle") { state.engraving.enabled = button.checked; state.engraving.selectedSlot = button.checked ? engravingSlot(state.selectedSlot) : null; state.engraving.error = ""; }
      if (action === "engraving-confirm") {
        const slot = state.engraving.selectedSlot?.index;
        const selected = slot === undefined ? null : state.slots[slot];
        state.engraving.error = engravingError(state.engraving.draftText);
        if (!selected) state.engraving.error = tr("請先點選手串一顆珠子", "Please select a bead on the bracelet first");
        if (state.engraving.error) { render(); app.querySelector('[data-action="engraving-text"]')?.focus(); return; }
        const engravingItem = {slot, beadId:selected.bead.id, beadName:selected.bead.name, size:`${selected.size}mm`, text:state.engraving.draftText.trim()};
        state.engraving.items = state.engraving.items.filter(item => item.slot !== slot).concat(engravingItem).sort((a,b) => a.slot - b.slot);
        state.engraving.draftText = "";
      }
      if (action === "engraving-remove") state.engraving.items = state.engraving.items.filter(item => item.slot !== Number(button.dataset.index));
      if (action === "slot") { state.selectedSlot = Number(button.dataset.index); state.engraving.selectedSlot = engravingSlot(state.selectedSlot); if (state.engraving.enabled) { state.engraving.draftText = state.engraving.items.find(item => item.slot === state.engraving.selectedSlot?.index)?.text || ""; state.engraving.error = ""; } }
      if (action === "add") { const bead=beads.find(item => item.id === button.dataset.id); const replacedSlot=state.selectedSlot; const next=state.slots.slice(); next[replacedSlot]=pick(bead,state.sizes[bead.id]); commit(next); state.engraving.items=state.engraving.items.filter(item => item.slot !== replacedSlot); const empty=nextEmptySlot(state.selectedSlot); if (empty >= 0) state.selectedSlot=empty; }
      if (action === "clear-bracelet") { commit(Array(MAX_SLOT_COUNT).fill(null)); state.selectedSlot=0; state.engraving.selectedSlot=null; state.engraving.items=[]; state.engraving.draftText=""; }
      if (action === "remove" && state.slots[state.selectedSlot]) { const removedSlot=state.selectedSlot; const next=state.slots.slice(); next[removedSlot]=null; commit(next); state.engraving.items=state.engraving.items.filter(item => item.slot !== removedSlot); if (state.engraving.selectedSlot?.index === removedSlot) state.engraving.selectedSlot=null; }
      if (action === "move" && state.slots[state.selectedSlot]) { const direction=Number(button.dataset.direction); const sourceSlot=state.selectedSlot; const count=visibleSlotCount(); const target=(sourceSlot+direction+count)%count; const next=state.slots.slice(); [next[sourceSlot],next[target]]=[next[target],next[sourceSlot]]; commit(next); state.engraving.items=state.engraving.items.map(item => item.slot === sourceSlot ? {...item,slot:target} : item.slot === target ? {...item,slot:sourceSlot} : item); state.selectedSlot=target; if (state.engraving.selectedSlot?.index === sourceSlot) state.engraving.selectedSlot=engravingSlot(target); else if (state.engraving.selectedSlot?.index === target) state.engraving.selectedSlot=engravingSlot(sourceSlot); }
      if (action === "repeat" && state.slots[state.selectedSlot]) { const target=nextEmptySlot(state.selectedSlot); if (target >= 0) { const next=state.slots.slice(); next[target]={...state.slots[state.selectedSlot]}; commit(next); state.selectedSlot=target; } }
      if (action === "undo" && state.history.length) { state.slots=state.history.pop(); state.engraving.items=state.engraving.items.filter(item => { const bead=state.slots[item.slot]; return bead && bead.bead.id === item.beadId && `${bead.size}mm` === item.size; }); state.engraving.selectedSlot=engravingSlot(state.engraving.selectedSlot?.index); }
      if (action === "finish") {
        if (!wristReady()) { render(); return; }
        state.finished=true;
        root.dispatchEvent(new CustomEvent("may:diy:complete",{bubbles:true,detail:{items:state.slots.filter(Boolean).map(item => ({diyId:item.bead.diyId,beadId:item.bead.id,name:item.bead.name,size:item.size,price:item.price})),properties:engravingProperties(),engravingItems:state.engraving.items.map(item => ({...item})),engravingPrice:state.engraving.enabled ? state.engraving.items.length * engravingPrice : 0}}));
      }
      if (action === "checkout") {
        const orderDesignId = designId();
        const orderedItems = designItems();
        const detail = {items:state.slots.filter(Boolean).map(item => ({diyId:item.bead.diyId,beadId:item.bead.id,name:item.bead.name,size:item.size,price:item.price,variantId:item.variantId})),properties:{...engravingProperties(),"DIY設計編號":orderDesignId,"珠子排列":designSequence(orderedItems),"目標手圍":`${state.targetWrist}cm`,"預估手圍":`${estimatedWrist().toFixed(1)}cm`},engravingItems:state.engraving.items.map(item => ({...item})),engravingPrice:state.engraving.enabled ? state.engraving.items.length * engravingPrice : 0};
        root.dispatchEvent(new CustomEvent("may:diy:checkout",{bubbles:true,detail}));
        const grouped = new Map();
        detail.items.forEach(item => { if (item.variantId) grouped.set(String(item.variantId), (grouped.get(String(item.variantId)) || 0) + 1); });
        if (!grouped.size) { alert(tr("目前缺少商品規格 ID，請稍後再試。", "A product variant ID is missing. Please try again later.")); return; }
        button.disabled = true;
        button.textContent = designUploadUrl ? tr("正在儲存設計圖…", "Saving your design...") : tr("正在加入購物車…", "Adding to cart...");
        try {
          let designFiles = {url:"",previewUrl:""};

try {
  designFiles = await uploadDesign(orderDesignId, orderedItems) || designFiles;
} catch (uploadError) {
  console.error("May DIY design upload error", uploadError);
}

const privateProperties = {
  "_DIY設計編號":orderDesignId,
  "_珠子排列":designSequence(orderedItems),
  "_目標手圍":`${state.targetWrist}cm`,
  "_預估手圍":`${estimatedWrist().toFixed(1)}cm`
};

if (designFiles.url) {
  privateProperties["_查看設計圖"] = designFiles.url;
}

if (designFiles.previewUrl) {
  privateProperties["_設計預覽圖"] = designFiles.previewUrl;
}

const cartItems = [...grouped].map(([id,quantity], index) => ({
  id:Number(id),
  quantity,
  properties:index === 0
    ? {
        ...privateProperties,
        "_DIY單組數量":String(quantity),
        ...(isEnglish
          ? {"DIY Custom":"Custom Bracelet", "Wrist Size":`${state.targetWrist}cm`}
          : {"DIY客製":"專屬手串", "手圍":`${state.targetWrist}cm`}),
        ...engravingProperties()
      }
    : {
        ...privateProperties,
        "_DIY單組數量":String(quantity)
      }
}));

const response = await fetch("/cart/add.js", {
  method: "POST",
  headers: {"Content-Type": "application/json"},
  body: JSON.stringify({items: cartItems})
});  
          if (!response.ok) throw new Error(await response.text());
          window.location.href = "/cart";
        } catch (error) {
          console.error("May DIY cart error", error);
          alert(tr("加入購物車失敗，請重新整理後再試。", "Could not add the design to cart. Please refresh and try again."));
          button.disabled = false;
          button.textContent = tr("前往結算", "Proceed to Checkout");
        }
      }
      if (action === "close") state.finished=false;
      render();
      if (returnToResults) app.querySelector(".result-title")?.scrollIntoView({block:"start",behavior:"auto"});
    });

    function pointerSlot(event) {
  const bracelet = app.querySelector(".mini-bracelet");
  if (!bracelet) return null;

  const rect = bracelet.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;

  let angle =
    Math.atan2(event.clientY - centerY, event.clientX - centerX) *
    180 /
    Math.PI;

  angle = (angle + 450) % 360;

  const count = visibleSlotCount();
  return Math.round(angle / (360 / count)) % count;
}

function clearDragClasses() {
  app.querySelectorAll(".mini-slot").forEach(slot => {
    slot.classList.remove("is-dragging", "is-drop-target");
  });
}

app.addEventListener("pointerdown", event => {
  const slot = event.target.closest('[data-action="slot"]');
  if (!slot) return;

  const index = Number(slot.dataset.index);
  if (!state.slots[index]) return;

  event.preventDefault();
  slot.setPointerCapture(event.pointerId);

  dragData = {
    source: index,
    target: index,
    startX: event.clientX,
    startY: event.clientY,
    dragging: false
  };
});

app.addEventListener("pointermove", event => {
  if (!dragData) return;

  const distance = Math.hypot(
    event.clientX - dragData.startX,
    event.clientY - dragData.startY
  );

  if (distance < 6 && !dragData.dragging) return;

  dragData.dragging = true;
  event.preventDefault();

  const target = pointerSlot(event);
  if (target === null) return;

  dragData.target = target;
  clearDragClasses();

  app
    .querySelector(`[data-index="${dragData.source}"]`)
    ?.classList.add("is-dragging");

  app
    .querySelector(`[data-index="${target}"]`)
    ?.classList.add("is-drop-target");
});

function finishDrag() {
  if (!dragData) return;

  const { source, target, dragging } = dragData;

  if (dragging && source !== target) {
    const next = state.slots.slice();

    [next[source], next[target]] = [
      next[target],
      next[source]
    ];

    commit(next);

    state.engraving.items = state.engraving.items.map(item => {
      if (item.slot === source) return { ...item, slot: target };
      if (item.slot === target) return { ...item, slot: source };
      return item;
    });

    state.selectedSlot = target;
    state.engraving.selectedSlot = engravingSlot(target);
    suppressNextClick = true;

    setTimeout(() => {
      suppressNextClick = false;
    }, 0);
  }

  dragData = null;
  clearDragClasses();

  if (dragging) render();
}

app.addEventListener("pointerup", finishDrag);
app.addEventListener("pointercancel", finishDrag);
    render();
  }
  function initAll(scope) { (scope || document).querySelectorAll("[data-may-diy-studio]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll(document)); else initAll(document);
  document.addEventListener("shopify:section:load", event => initAll(event.target));
})();
